module.exports = __webpack_public_path__ + "img/alipay.40bee53c.jpg";